<template lang="pug">
  v-container.text-wrap(grid-list-sm)
    v-form(v-model="formModel")
      v-row(dense)
        v-col
          slot(name="header")
      v-divider.mt-2
      slot(name="content")
      slot(name="image")
</template>

<script>
import { computed } from '@vue/composition-api'

export default {
  props: {
    form: Boolean
  },

  setup (props, { emit }) {
    const formModel = computed({
      get: () => props.form,
      set: value => {
        emit(`update:form`, value)
      }
    })

    return {
      formModel
    }
  }
}
</script>
